var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "../../components/templates/flex";
import { webkitVisibleScrollbar } from "../../mixins";
var Container = styled(Flex).attrs({
    overflow: { vertical: "auto" },
    padding: [0, 4, 0, 0],
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), webkitVisibleScrollbar);
export default Container;
var templateObject_1;
